import { render, staticRenderFns } from "./PromotionChooser.vue?vue&type=template&id=59b7d111&scoped=true&"
import script from "./PromotionChooser.vue?vue&type=script&lang=js&"
export * from "./PromotionChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b7d111",
  null
  
)

export default component.exports